module.exports = __webpack_public_path__ + "img/LogoDashboard-23.549f7911.svg";